<script setup lang="ts">
const { t } = useI18n();

const head = useLocaleHead({ addSeoAttributes: true });

useSchemaOrg([
  defineWebPage(),
  defineWebSite({
    name: "Contrat IA",
    description: t("schemaOrg.description"),
  }),
  defineOrganization({
    name: "Contrat IA",
    url: "https://contrat-ia.com",
    logo: "https://contrat-ia.com/apple-touch-icon.png",
    sameAs: [
      "https://bsky.app/profile/contrat-ia.com",
      "https://www.linkedin.com/company/contrat-ia",
      "https://github.com/contrat-ia",
      "https://www.youtube.com/@contrat-ia",
      "https://read.cv/teams/contratia",
    ],
    description: t("schemaOrg.shortDescription"),
    email: "contact@contrat-ia.com",
    vatID: "FR15891038218",
  }),
]);
</script>

<template>
  <Html
    class="bg-white"
    :lang="head.htmlAttrs.lang"
    :dir="head.htmlAttrs.dir"
  >
    <Head>
      <template
        v-for="link in head.link"
        :key="link.key"
      >
        <Link
          :id="link.key"
          :rel="link.rel"
          :href="link.href"
          :hreflang="link.hreflang"
        />
      </template>
      <template
        v-for="meta in head.meta"
        :key="meta.key"
      >
        <Meta
          :id="meta.key"
          :property="meta.property"
          :content="meta.content"
        />
      </template>
      <Link
        rel="icon"
        type="image/png"
        href="/favicon-96x96.png"
        sizes="96x96"
      />
      <Link
        rel="icon"
        type="image/svg+xml"
        href="/favicon.svg"
      />
      <Link
        rel="shortcut icon"
        href="/favicon.ico"
      />
      <Link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <Meta
        name="apple-mobile-web-app-title"
        content="Contrat IA"
      />
      <Link
        rel="manifest"
        href="/site.webmanifest"
      />
    </Head>
    <Body>
      <NuxtLoadingIndicator />
      <NuxtRouteAnnouncer />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>

      <UNotifications />
    </Body>
  </Html>
</template>
